module.exports = __webpack_public_path__ + "img/archive.7e6aa68f.svg";